module.exports = window["MaterialUI"].Table;